import { Component, OnDestroy, OnInit } from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {NgClass, NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import { versions } from '../../environments/version';
import {BsModalService} from "ngx-bootstrap/modal";
import {ModalCerrarSesionComponent} from "../modals/modal-cerrar-sesion/modal-cerrar-sesion.component";
import {ModalPerfilComponent} from "../modals/modal-perfil/modal-perfil.component";
import {jwtDecode} from 'jwt-decode';
import {UserService} from "../services/user.service";
import {ImportadorService} from "../services/importador.service";
import {SucursalService} from "../services/sucursal.service";
import {CambiarSucursalComponent} from "../modals/cambiar-sucursal/cambiar-sucursal.component";
import {UsuarioModel} from "../../models/usuario.model";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    RouterOutlet,
    NgClass,
    RouterLink,
    RouterLinkActive,
    NgIf
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit, OnDestroy {

  menuColap: boolean = false;
  gitV: string;
  gitH: string;
  usuario: UsuarioModel;
  envName: string;
  permisoImportador: boolean = false;
  cantidadSucursalesSeleccionadas: number = 0;
  private sucursalesSub: Subscription;

  constructor(private modalService: BsModalService, private userService: UserService,
              private importadorService: ImportadorService, private sucursalService: SucursalService) {
  }

  ngOnInit() {
    this.gitV = `V ${versions.version}`;
    this.gitH = `Rev: ${versions.revision}`;
    this.envName = environment.envName;
    this.usuario = this.userService.getUsuario();
    this.importadorService.verificarPermiso().subscribe(permiso => {
      this.permisoImportador = permiso;
    });
    this.sucursalesSub = this.sucursalService.sucursales$.subscribe(sucursales => {
      this.cantidadSucursalesSeleccionadas = sucursales.length;
    });
    if (this.sucursalService.getSucursalesSeleccionadas().length === 0) {
      this.forzarSeleccionSucursal();
    }
  }

  ngOnDestroy() {
    this.sucursalesSub?.unsubscribe();
  }

  private forzarSeleccionSucursal() {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered modal-md',
      initialState: { forzado: true }
    });
  }


  showModalPerfil() {
    this.modalService.show(ModalPerfilComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  tienePermisoJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_VER_VISTA');
  }

  tienePermisoConductores(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_VER_VISTA');
  }

  tienePermisoDespachador(): boolean {
    return this.userService.tienePermiso('DESPACHADOR_VER_VISTA');
  }

  tienePermisoSinoptico(): boolean {
    return this.userService.tienePermiso('SINOPTICO_VER_VISTA');
  }

  tienePermisoGestionBuses(): boolean {
    return this.userService.tienePermiso('BUSES_VER_VISTA');
  }


}
